<div class="profile-container" [class.collapsed]="collapsed">
  <div class="avatar-circle">
    {{ getInitials(userData?.name, userData?.lastname) }}
  </div>

  <div class="user-info" *ngIf="!collapsed">
    <h3 class="user-name">
      {{roleTranslationKey | translate}}
    </h3>

    <div class="org-badge" *ngIf="userData?.organization?.businessName">
      <mat-icon class="org-icon">business</mat-icon>
      <span class="org-text">{{userData?.organization?.businessName}}</span>
    </div>
  </div>
</div>
